module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318947.ba755b9d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318947.pdf
// module id = 840
// module chunks = 0